import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Manifesto from "@/components/site/Manifesto";
import ClientMarquee from "@/components/site/ClientMarquee";
import Services from "@/components/site/Services";
import Metrics from "@/components/site/Metrics";
import Process from "@/components/site/Process";
import Industries from "@/components/site/Industries";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="relative bg-[#050505]" data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Manifesto />
      <ClientMarquee />
      <Services />
      <Metrics />
      <Process />
      <Industries />
      <Contact />
      <Footer />
    </main>
  );
}
